export const isVector4D = (v) => {
    return v.w !== undefined;
};
